import { environmentDev } from '@config';
import { EnvironmentModel } from '@libs/shared/common';

export const environment: EnvironmentModel = {
  ...environmentDev,
  links: {
    ...environmentDev.links,
    appUrl: 'https://app.dev.lekkerland.io/',
  },
  app: {
    applicationId: 'CEP',
    context: 'login',
    baseHref: 'https://app.dev.lekkerland.io',
    gtmID: 'GTM-KLK9ZVP',
  },
};
